// Packages
import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import "@govtechsg/sgds/css/sgds.css";
import "@govtechsg/sgds-masthead/dist/sgds-masthead/sgds-masthead.css";
// import '@govtechsg/sgds/css/sgds.scss'

// Pages
import Register from "./js/Register";
import Home from "./js/Home";
// import APIDocumentation from './js/APIDocs3'
import ContactUs from "./js/ContactUs";
import RegisterConfirm from "./js/RegisterConfirm";
import ForgetPassword from "./js/ForgetPassword";
import ResetPassword from "./js/ResetPassword";
import RegisterSuccess from "./js/RegisterSuccess";
import ResetPasswordSuccess from "./js/ResetPasswordSuccess";
import MCP from "./js/MCP";
import ReactGA from "react-ga4";
import setWOGAA from "./js/om.api";

import MapsServices from "./js/api/MapsServices";
import SearchServices from "./js/api/SearchServices";
import NearbyTransportServices from "./js/api/NearbyTransportServices";
import AuthenticationServices from "./js/api/AuthenticationServices";
import ReverseGeocodeServices from "./js/api/ReverseGeocodeServices";
import RoutingServices from "./js/api/RoutingServices";
import BfaServices from "./js/api/BfaServices";
import CoordinateServices from "./js/api/CoordinateServices";
import ThemeServices from "./js/api/ThemeServices";
import PlanningAreaServices from "./js/api/PlanningAreaServices";
import PopulationQueryServices from "./js/api/PopulationQueryServices";
import StaticMapServices from "./js/api/StaticMapServices";
import TokenManagement from "./js/docs/TokenManagement";
import WorkshopMay2025 from "./js/docs/WorkshopMay2025";
import WorkshopAug2025 from "./js/docs/WorkshopAug2025";
import JWTTokenUpdate from "./js/docs/JWTTokenUpdate";
import VerifyingSearchAPIToken from "./js/docs/verifyingSearchAPIToken";

import Blog from "./js/docs/Blog";

let gatoken = setWOGAA();
ReactGA.initialize(gatoken);

const App = () => {
  useEffect(() => {
    ReactGA.initialize(gatoken);
  }, []);
  return (
    <GoogleReCaptchaProvider reCaptchaKey={`${process.env.REACT_APP_SITE_KEY}`}>
      <HelmetProvider>
        <BrowserRouter basename="/apidocs">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apidocs" element={<Navigate to="/maps" replace />} />

            {/* API Services Routes */}
            <Route path="/maps" element={<MapsServices />} />
            <Route path="/search" element={<SearchServices />} />
            <Route
              path="/nearbytransport"
              element={<NearbyTransportServices />}
            />
            <Route
              path="/authentication"
              element={<AuthenticationServices />}
            />
            <Route
              path="/reversegeocode"
              element={<ReverseGeocodeServices />}
            />
            <Route path="/routing" element={<RoutingServices />} />
            <Route path="/bfa" element={<BfaServices />} />
            <Route path="/coordinate" element={<CoordinateServices />} />
            <Route path="/themes" element={<ThemeServices />} />
            <Route path="/planningarea" element={<PlanningAreaServices />} />
            <Route
              path="/populationquery"
              element={<PopulationQueryServices />}
            />
            <Route path="/staticmap" element={<StaticMapServices />} />
            <Route path="/mcp" element={<MCP />} />

            {/* User Management Routes */}
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/register" element={<Register />} />
            <Route path="/registerconfirm" element={<RegisterConfirm />} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/registersuccess" element={<RegisterSuccess />} />
            <Route
              path="/resetpasswordsuccess"
              element={<ResetPasswordSuccess />}
            />

            {/* Documentation Routes */}
            <Route path="/docs/blog" element={<Blog />} />
            <Route path="/docs/tokenmanagement" element={<TokenManagement />} />
            <Route path="/docs/workshopmay2025" element={<WorkshopMay2025 />} />
            <Route path="/docs/workshopaug2025" element={<WorkshopAug2025 />} />
            <Route path="/docs/jwttokenupdate" element={<JWTTokenUpdate />} />
            <Route
              path="/docs/verifyingsearchapitoken"
              element={<VerifyingSearchAPIToken />}
            />

            {/* Catch-all route for 404 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </GoogleReCaptchaProvider>
  );
};
export default App;
